import { APP_TRANSACTION, TRANSACTION_HISTORY } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { MobiSimRegistrationRequestModel } from "features/mobiSimRegistration/data/model/MobiSimRegistrationRequestModel";
import { MobiSimRegistrationResponseModel } from "features/mobiSimRegistration/data/model/MobiSimRegistrationResponseModel";
import { IMobiSimRegistrationRepository } from "features/mobiSimRegistration/domain/repositories/IMobiSimRegistrationRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";

@injectable()
export class MobiSimRegistrationImpl implements IMobiSimRegistrationRepository {
  async getList(
    params: MobiSimRegistrationRequestModel,
  ): Promise<ListBaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    const url = StringFormat.buildListUrl<MobiSimRegistrationRequestModel>(
      TRANSACTION_HISTORY.MOBISIMLIST,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getDetail(
    params: MobiSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    return await client.get(
      `${TRANSACTION_HISTORY.MOBISIMLIST}/${params?.code}`,
    );
  }

  async exportReport(
    params: MobiSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      TRANSACTION_HISTORY.MOBISIMLIST,
      params,
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }

  async checkStatus(
    code: string,
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    return await client?.get(APP_TRANSACTION?.CHECK_STATUS, { code });
  }
}
